export default __webpack_public_path__ + "static/media/new_game.2afbfc7a.png";